import { App, OpenWebUrlTarget } from '@servicetitan/web-feature-app-service';

const HTTP_PROTOCOLS = new Set(['http:', 'https:']);

/**
 * Returns true only for absolute http(s) URLs. Rejects javascript:, data:, and other schemes
 * that must never be passed to window.open / location.href.
 */
export const isSafeHttpUrl = (url: string | null | undefined): url is string => {
    if (!url) {
        return false;
    }

    try {
        const parsed = new URL(url);
        return HTTP_PROTOCOLS.has(parsed.protocol);
    } catch {
        return false;
    }
};

/**
 * Opens a web URL using the appropriate target based on setup data configuration
 * Falls back to window.open if App.openWebUrl fails
 *
 * @param url - The URL to open
 * @param useInAppBrowser - Whether to use in-app browser or external browser
 */
export const openWebUrl = (url: string, useInAppBrowser?: boolean): Promise<void> => {
    if (!isSafeHttpUrl(url)) {
        return Promise.resolve();
    }

    const target = useInAppBrowser ? OpenWebUrlTarget.InApp : OpenWebUrlTarget.Browser;

    return App.openWebUrl({
        url,
        target,
    }).catch(() => {
        // Fallback to original behavior
        const windowResult = window.open(url, '_blank');
        if (windowResult === null) {
            window.location.href = url;
        }
    });
};
